import type { IPurchaserRepository } from "@src/domain/repositories/purchaser";
import type { PurchaserLookupItem } from "@src/domain/dto/purchasers";

export class GetBrandAssociatedPurchasersLookupUseCase {
  private readonly purchaserRepository: IPurchaserRepository;

  constructor(purchaserRepository: IPurchaserRepository) {
    this.purchaserRepository = purchaserRepository;
  }

  execute(brandId: number): Promise<{ items: PurchaserLookupItem[]; count: number }> {
    return this.purchaserRepository.getBrandAssociatedPurchasersLookup(brandId);
  }
}
